import { render, staticRenderFns } from "./chatDialogComponent.vue?vue&type=template&id=512f635a&scoped=true"
import script from "./chatDialogComponent.vue?vue&type=script&lang=js"
export * from "./chatDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f635a",
  null
  
)

export default component.exports